import React from 'react'
import clsx from 'clsx'
import styles from './UIGameHelpUserSettingsButton.module.scss'
import {Dropdown} from '../../../common/Dropdown'
import {T} from '../../../common/T'
/* eslint-disable no-restricted-imports */
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage, ModeSettingEnum} from '@colonist/types'
import {useUIGameHelpRulesButtonContext} from '../UIGameHelpRulesButton/UIGameHelpRulesButtonContext'
import {useUIGameHelpLeaveGameContext} from '../UIGameHelpLeaveGameContext'
import {useGameStore} from '../../../store/GameStoreContext'
import {useIsReplay} from '../../../store/selectors/useIsReplay'

export interface UIGameHelpUserSettingsButtonProps {
    className?: string
    isPlayerSpectator: boolean
    isRulesOptionVisible: boolean
    isGameInfoOptionVisible: boolean
    onSettingsClick: () => void
    onPauseGameClick: () => void
    onDisableKarmaClick: () => void
    onGameInfoClick: () => void
}

export const UIGameHelpUserSettingsButton = ({
    className,
    isPlayerSpectator,
    isRulesOptionVisible,
    isGameInfoOptionVisible,
    onSettingsClick,
    onPauseGameClick,
    onDisableKarmaClick,
    onGameInfoClick,
}: UIGameHelpUserSettingsButtonProps) => {
    const {showRulesPopup} = useUIGameHelpRulesButtonContext()
    const {canResign, leaveGame} = useUIGameHelpLeaveGameContext()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isReplay = useIsReplay()
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    const options: {
        label: React.ReactNode
        onClick: VoidFunction
        hidden?: boolean | undefined
        disabled?: boolean | undefined
    }[] = [
        {
            label: (<T id={{key: 'strings:game.gearIcon.settings'}} />),
            onClick: onSettingsClick,
        },
        {
            label: (<T id={{key: 'strings:game.settings.gameInfoTab.title'}} />),
            onClick: onGameInfoClick,
            hidden: !isGameInfoOptionVisible,
        },
        {
            label: (<T id={{key: 'strings:game.gearIcon.pauseGame'}} />),
            onClick: onPauseGameClick,
            disabled: isPlayerSpectator,
            hidden: isReplay,
        },
        {
            label: (<T id={{key: 'strings:game.gearIcon.disableKarma'}} />),
            onClick: onDisableKarmaClick,
            disabled: isPlayerSpectator,
            hidden: isReplay || isBeginnerMode,
        },
        {
            label: (<T id={{key: 'strings:rulebook.title'}} />),
            onClick: showRulesPopup,
            hidden: !isRulesOptionVisible,
        },
        {
            label: (<div className={styles.red}>
                <T id={{key: 'strings:game.gearIcon.resignGame'}} />
            </div>),
            onClick: leaveGame,
            hidden: canResign === false || isPlayerSpectator || isReplay,
        },
        {
            label: (
                <div className={styles.red}>
                    <T id={{key: 'strings:game.gearIcon.leaveGame'}} />
                </div>
            ),
            onClick: leaveGame,
            hidden: (canResign === true && !isPlayerSpectator),
        },
    ]

    return (
        <div>
            <Dropdown
                className={styles.dropdownContainer}
                options={options}
                placement='right-start'>
                <img
                    className={clsx(styles.settingsButton, className)}
                    src={getLobbyImagePath(LobbyImage.Settings)}/>
            </Dropdown>
        </div>
    )
}
